import { useEffect, useState } from "react";

export default function BackTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      type="button"
      aria-label="回到顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full border border-background-200 bg-background-50 text-primary-600 shadow-lg transition-all hover:bg-primary-500 hover:text-background-50"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}